import { CloseOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { Carousel } from "antd";
export function ShowBigImgPC(props) {
  let { hide, data, url } = props;

  return (
    <div className="fixedcanvas">
      <div
        className="Exit-btn"
        onClick={() => {
          hide();
        }}
      >
        <CloseOutlined />
      </div>
      <CollectionBigImg data={data} currenturl={url} />
    </div>
  );
}

function CollectionBigImg(props) {
  let { data, currenturl } = props;
  const [page, setPage] = useState(data.findIndex((i) => i === currenturl));
  return (
    <div className="largecollect-box">
      <div className="middle-content-img">
        <div
          className="onclick-leftarrow"
          onClick={() => {
            setPage((state) => (state === 0 ? data.length - 1 : state - 1));
          }}
        ></div>
        <div className="slide-img-content">
          {data.map((i, index) => {
            return (
              <div
                key={i}
                style={
                  index === page
                    ? { opacity: 1, transition: "1s all" }
                    : { opacity: 0 }
                }
              >
                <img
                  alt="jiazaiz"
                  src={i}
                  width="100%"
                  height="100%"
                  style={{ objectFit: "contain" }}
                />
              </div>
            );
          })}
        </div>
        <div
          className="onclick-rightarrow"
          onClick={() => {
            setPage((state) => (state >= data.length - 1 ? 0 : state + 1));
          }}
        ></div>
      </div>
      <div className="page-bottom-style">
        {page + 1}/{data.length}
      </div>
    </div>
  );
}

// export  function PortfolioImg(props){
//   let {index,data,hide} =props
//   const [page,setPage] = useState(data.findIndex(i=>i===index))

//   const imgref=useRef()

//   useEffect(()=>{
//     imgref.current.goTo(page,true)
//   },[index,data])
//   console.log(index,page)
//   return(
//     <div className="fixedcanvaph">
//       <div className="Exit-btnph" onClick={()=>{hide()}}><CloseOutlined/></div>
//       <div className="portfolioart">
//         <div className="portfolioart-img">
//           <Carousel dots={false} ref={imgref}   beforeChange={(_,next)=>{
//             console.log(next)
//             setPage(next+1)
//           }} >
//             {
//               data?data.map((i)=>{
//                 return(
//                   <div className="big-img-box" key={i}>
//                     <img alt="jiazaiz" src={i} width="100%" height="100%" style={{objectFit:"contain"}}/>
//                   </div>
//                 )
//               }):''
//             }
//           </Carousel>
//         </div>
//         <div className="portfolioart-page">{page}/{data.length}</div>
//       </div>
//     </div>
//   )
// }

export class PortfolioImg extends React.Component {
  state = {
    page: this.props.index + 1,
    page2: this.props.index + 1,
  };

  componentDidMount() {
    this.ImagBox.goTo(this.props.index, true);
    console.log(this.props.index);
  }

  settings = {
    speed: 300,
  };
  // beforeChange={(_,next)=>{
  //     this.setState({
  //       page2:next
  //     })
  //   }}
  render() {
    return (
      <div className="fixedcanvaph">
        <div
          className="Exit-btnph"
          onClick={() => {
            this.props.hide();
          }}
        >
          <CloseOutlined />
        </div>
        <div className="portfolioart">
          <div className="portfolioart-img">
            <Carousel
              beforeChange={(_, next) => {
                this.setState({
                  page2: next,
                });
              }}
              slickGoTo={this.state.page}
              ref={(id) => (this.ImagBox = id)}
              dots={false}
              afterChange={(index) => {
                this.setState({
                  page: index + 1,
                });
              }}
              {...this.settings}
            >
              {this.props.change.map((i) => {
                return (
                  <div className="big-img-box" key={i}>
                    {" "}
                    <img
                      width="100%"
                      height="100%"
                      style={{ objectFit: "contain" }}
                      alt="jiazaiz"
                      src={i}
                    />
                  </div>
                );
              })}
            </Carousel>
          </div>
          <div className="portfolioart-page">
            {this.state.page2 + 1}/{this.props.change.length}
          </div>
        </div>
      </div>
    );
  }
}
